import { useHistory } from 'react-router-dom';
import AvatarImage from '../AvaterImage';
import { formatUserCanadianStatus, getNameInitials } from '../../utils/helpers';

import './UserDetailsCardCa.scss';

interface IUserDetailsCard{
  payload?:any;
  fetchUser?:any;
  dropdownType?:string;
  hideLocation?:boolean;
  hasLoanPromise?:boolean;
  hasItems?:any;
  loanId?:string;
  showAvatarOrInitials?: boolean;
  children?: any;
  paddingBottom?: string;
  paddingTop?: string;
  showStatusBesideName?:boolean
}
const UserDetailsCardCa = ({
  payload, children, showAvatarOrInitials, paddingBottom, paddingTop, showStatusBesideName,
}: IUserDetailsCard) => {
  const { push } = useHistory();
  const avatar = payload?.imageUrl || '';
  const activeStatusSwitch = payload?.userRtDetail && !['in_review_rejected', 'ongoing', 'in_review'].includes(payload?.userRtDetail?.onboardingStatus);

  const userCanadianStatus = formatUserCanadianStatus(
    payload?.userRtDetail?.enrollment_type_other || payload?.userRtDetail?.enrollment_type,
    [['permanent resident', 'resident']],
  );

  return (
    <div
      className="user-details-card-cover"
      style={{
        paddingBottom, paddingTop,
      }}
    >
      <div className="user-details-card">
        <div className="details-div-cover">
          {showAvatarOrInitials && (

          <div className="user-avatar-div">
            { avatar
              ? <AvatarImage image={avatar} />
              : (
                <div className="avatar-initials">
                  {getNameInitials(payload?.name)}
                </div>
              )}
          </div>
          )}
          <div className="user-name-and-email-details">
            <div className="name-details">
              <div className="name" onClick={() => payload?.userId && push(`/customers/customer-details/${payload?.userId}/profile`)}>
                {payload?.name}
                {' '}
                {
                  showStatusBesideName && <div className={`user-${payload?.status}`}>{payload?.status}</div>
                }

              </div>
            </div>
            <div className="email-details">
              <div className="email-text">
                {payload?.email}
              </div>
            </div>
          </div>
        </div>
        <div className="onboarding-status-cover">
          {children || (
            <>
              <div className="onboarding-status-and-switch">
                <div className="active-toggle-switch">
                  <label className="status-text" htmlFor="toggle">
                    {activeStatusSwitch ? 'Active' : 'Inactive'}
                  </label>
                  <span className="switch">
                    <input id="toggle-checkbox" type="checkbox" defaultChecked={activeStatusSwitch} />
                    <span className="slider round" />
                  </span>
                </div>
              </div>

              <div className="canadian-status">
                <div className="canadian-status-text">
                  {userCanadianStatus}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

    </div>
  );
};
export default UserDetailsCardCa;
